import { render, staticRenderFns } from "./activityTip.vue?vue&type=template&id=39fd043c&scoped=true&"
import script from "./activityTip.vue?vue&type=script&lang=js&"
export * from "./activityTip.vue?vue&type=script&lang=js&"
import style0 from "./activityTip.vue?vue&type=style&index=0&id=39fd043c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd043c",
  null
  
)

export default component.exports